import { Injectable } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { alert } from 'devextreme/ui/dialog';
import { StorageService } from 'src/app/share/services/storage.service';
import { AuthService } from 'src/app/share/services/auth.service';

@Injectable()
export class LogoutMonitoringService {
  private timerSubscription: Subscription | null = null;

  constructor(private storageService: StorageService, private authService: AuthService) {}

  init() {
    const startTime = new Date();
    const endTime = new Date(this.storageService.getFromSession<string>('expires'));
    const timeToLogout = endTime.getTime() - 10000 - startTime.getTime(); // 10 sec Puffer
    const timeToRemain = 300000; // 5 min vorher
    const timeToAlert = timeToLogout - timeToRemain;
    const minToRemain = Math.floor(timeToRemain / 60000);

    this.stop();
    this.timerSubscription = timer(timeToAlert).subscribe(() => {
      alert('Sie werden aus Sicherheitsgründen in ' + minToRemain + ' min automatisch abgemeldet.', 'ACHTUNG');
    });

    this.timerSubscription = timer(timeToLogout).subscribe(() => {
      this.authService.logout();
      alert('Sie wurden aus Sicherheitsgründen automatisch abgemeldet.', 'ACHTUNG');
    });
  }

  stop() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription.closed = true;
      this.timerSubscription.remove(this.timerSubscription);
    }
  }
}
